import React from 'react';
import { FaArrowRight } from "react-icons/fa";
import Header from "../../components/layout/Header";
import Banner from "../../components/home/Banner";
import Footer from "../../components/layout/Footer";

const Beauty = () => {
    const banners = [
        "/beauty_hero.png",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/36735235f3da1176.jpg?q=20",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/edb327f27a650f96.jpg?q=20",
    ];

    const kBeautyItems = [
        { brand: "MISSHA", off: "Up to 30% Off", img: "https://rukminim1.flixcart.com/image/416/416/xif0q/face-wash/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
        { brand: "THE FACE SHOP", off: "Up to 45% Off", img: "https://rukminim1.flixcart.com/image/416/416/xif0q/face-wash/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
        { brand: "I'm from", off: "Up to 10% Off", img: "https://rukminim1.flixcart.com/image/416/416/xif0q/face-wash/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
        { brand: "L'ador", off: "Up to 10% Off", img: "https://rukminim1.flixcart.com/image/416/416/xif0q/face-wash/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
        { brand: "COSRX", off: "Up to 30% Off", img: "https://rukminim1.flixcart.com/image/416/416/xif0q/face-wash/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
    ];

    const storeItems = [
        { title: "Sun-care Paglu Sale", bg: "#ffd54f", img: "/beauty_category_1.png" },
        { title: "Luxe Beauty", bg: "#fff3e0", img: "/beauty_category_2.png" },
        { title: "The Derma Promise", bg: "#80deea", img: "/beauty_category_3.png" },
        { title: "K-Glam Shop", bg: "#b39ddb", img: "https://static-assets-web.flixcart.com/fk-p-flap/128/128/image/3b12ea642f89f924.jpg?q=20" },
        { title: "Spa & Beauty", bg: "#f48fb1", img: "https://static-assets-web.flixcart.com/fk-p-flap/128/128/image/1d34c62dd9806e23.jpg?q=20" },
    ];

    const guideSteps = [
        { n: "1", title: "Cleansers", off: "Up to 75% Off", img: "https://rukminim1.flixcart.com/image/612/612/xif0q/face-wash/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
        { n: "2", title: "Face scrubs", off: "Up to 80% Off", img: "https://rukminim1.flixcart.com/image/612/612/xif0q/face-wash/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
        { n: "3", title: "Toners", off: "Under ₹299", img: "https://rukminim1.flixcart.com/image/612/612/xif0q/face-wash/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
        { n: "4", title: "Serums", off: "Under ₹399", img: "https://rukminim1.flixcart.com/image/612/612/xif0q/face-wash/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
        { n: "5", title: "Moisturizers", off: "Min. 40% Off", img: "https://rukminim1.flixcart.com/image/612/612/xif0q/face-wash/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" },
    ];

    return (
        <div style={{ backgroundColor: '#f1f2f4', minHeight: '100vh', paddingTop: '128px' }}>
            <Header />

            <div style={{ maxWidth: '1440px', margin: '0 auto', padding: '12px 16px' }}>

                {/* Main Scrolling Banners */}
                <div style={{ marginBottom: '24px', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
                    <Banner images={banners} height="300px" />
                </div>

                {/* K-Beauty obsessed? Section */}
                <div style={{ marginBottom: '40px' }}>
                    <h2 style={{ fontSize: '22px', marginBottom: '24px', textAlign: 'start', fontWeight: '800' }}>K-Beauty obsessed?</h2>
                    <div style={{ display: 'flex', gap: '24px', overflowX: 'auto', paddingBottom: '16px' }} className="no-scrollbar">
                        {kBeautyItems.map((item, i) => (
                            <div
                                key={i}
                                style={{
                                    minWidth: '240px',
                                    backgroundColor: 'white',
                                    borderRadius: '28px',
                                    padding: '24px',
                                    textAlign: 'start',
                                    position: 'relative',
                                    border: '1px solid #f0f0f0',
                                    boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
                                    transition: '0.3s'
                                }}
                            >
                                <p style={{ position: 'absolute', top: '24px', left: '24px', fontSize: '14px', fontWeight: '900', color: '#333', letterSpacing: '1px', margin: 0 }}>{item.brand}</p>
                                <div style={{ height: '200px', margin: '24px 0' }}>
                                    <img src={item.img} alt={item.brand} style={{ height: '100%', margin: '0 auto', objectFit: 'contain' }} />
                                </div>
                                <p style={{ fontWeight: '900', fontSize: '18px', color: '#d81b60', margin: 0 }}>{item.off}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Explore our stores Section */}
                <div style={{ marginBottom: '48px' }}>
                    <h2 style={{ fontSize: '22px', marginBottom: '24px', textAlign: 'start', fontWeight: '800' }}>Explore our stores</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '24px' }}>
                        {storeItems.map((item, i) => (
                            <div
                                key={i}
                                style={{
                                    backgroundColor: item.bg,
                                    borderRadius: '28px',
                                    padding: '32px',
                                    height: '340px',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    cursor: 'pointer',
                                    transition: '0.4s'
                                }}
                            >
                                <div style={{ position: 'relative', zIndex: 2 }}>
                                    <h3 style={{ fontSize: '20px', fontWeight: '900', lineHeight: '1.1', color: 'rgba(0,0,0,0.8)', margin: 0 }}>{item.title}</h3>
                                    <div style={{ width: '36px', height: '36px', backgroundColor: 'white', marginTop: '24px', borderRadius: '50%', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <FaArrowRight size="14px" />
                                    </div>
                                </div>
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    style={{
                                        position: 'absolute',
                                        bottom: '-40px',
                                        right: '-40px',
                                        height: '200px',
                                        objectFit: 'contain',
                                        zIndex: 1
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Glow up Guide Section */}
                <div style={{ marginBottom: '56px' }}>
                    <h2 style={{ fontSize: '22px', marginBottom: '32px', textAlign: 'start', fontWeight: '800' }}>Glow up Guide</h2>
                    <div style={{ display: 'flex', gap: '48px', overflowX: 'auto', paddingBottom: '24px' }} className="no-scrollbar">
                        {guideSteps.map((step, i) => (
                            <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: '220px', position: 'relative' }}>
                                <div style={{ position: 'relative' }}>
                                    <span
                                        style={{
                                            position: 'absolute',
                                            left: '-30px',
                                            top: '-40px',
                                            fontSize: '120px',
                                            fontWeight: '900',
                                            color: 'rgba(0,0,0,0.1)',
                                            zIndex: 0,
                                            userSelect: 'none'
                                        }}
                                    >
                                        {step.n}
                                    </span>
                                    <div
                                        style={{
                                            width: '180px',
                                            height: '260px',
                                            backgroundColor: '#ffebf2',
                                            borderRadius: '100px',
                                            position: 'relative',
                                            overflow: 'hidden',
                                            marginLeft: '24px',
                                            zIndex: 1,
                                            boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.06)'
                                        }}
                                    >
                                        <img src={step.img} alt={step.title} style={{ height: '80%', width: '100%', objectFit: 'contain', marginTop: '32px', transition: '0.4s' }} />
                                    </div>
                                </div>
                                <div style={{ marginLeft: '32px', marginTop: '16px' }}>
                                    <p style={{ fontWeight: '900', fontSize: '20px', color: '#d81b60', margin: 0 }}>{step.title}</p>
                                    <p style={{ fontWeight: '700', fontSize: '16px', color: '#718096', margin: 0 }}>{step.off}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* New launches Section */}
                <div style={{ marginBottom: '48px', backgroundColor: '#fce4ec', padding: '40px', borderRadius: '32px', border: '1px solid #f8bbd0' }}>
                    <h2 style={{ color: '#880e4f', marginBottom: '32px', fontSize: '24px', textAlign: 'start', fontWeight: '900' }}>New launches on sale</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '32px' }}>
                        {[1, 2, 3, 4].map(i => (
                            <div key={i} style={{ backgroundColor: 'white', borderRadius: '24px', padding: '24px', textAlign: 'start', cursor: 'pointer', transition: '0.3s' }}>
                                <div style={{ height: '40px', marginBottom: '16px', backgroundColor: '#fdf2f8', borderRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #fbcce3' }}>
                                    <span style={{ fontWeight: '900', fontSize: '11px', color: '#d81b60', letterSpacing: '1px' }}>LUXE BRAND</span>
                                </div>
                                <p style={{ fontWeight: '900', fontSize: '18px', marginBottom: '16px', color: '#333' }}>Up to 60% Off</p>
                                <img src="https://rukminim1.flixcart.com/image/612/612/xif0q/face-wash/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" alt="Product" style={{ height: '180px', margin: '0 auto', objectFit: 'contain' }} />
                            </div>
                        ))}
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    );
};

export default Beauty;

